import { data } from "jquery";
import http from "./httpService";
// import  apiUrl  from ".././config.json";
const apiUrl = require("../config.json").apiUrl;
const paymentUrl = require("../config.json").paymentGatwayURI


export const getPaymentBanks = (data) => {
    const apiEndPoint = `${apiUrl}/CCAvenueBankDet`;
    return http.post(`${apiEndPoint}`,data);
  };

export const getSMSLink = (data) => {
    const apiEndPoint = `${apiUrl}/GetSMSMessage`;
    return http.post(`${apiEndPoint}`, data)
  }

export const getQRSMSReference = (data) => {
  const apiEndPoint = `${apiUrl}/QRSMSMsg`;
  return http.post(`${apiEndPoint}`, data)
} 

export const getPaymentConfirmation = (data) => {
  const apiEndPoint = `${apiUrl}/CM_GenerateManualTicket`;
  return http.post(`${apiEndPoint}`, data)
} 

export const postSuccessOnlineBookingAfterTrans = (data) => {
  const apiEndPoint = `${apiUrl}/SuccessOnlineBoatBookingAftrTran`
  return http.post(`${apiEndPoint}`, data)
}

export const postPaymentHdfcData = (data) => {
  const apiEndPoint = `${paymentUrl}/ccavRequestHandler`
  return http.post(`${apiEndPoint}`, data)
}

